import { render, staticRenderFns } from "./PuiSelect22082024.vue?vue&type=template&id=d1333770"
import script from "./PuiSelect22082024.vue?vue&type=script&lang=js"
export * from "./PuiSelect22082024.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports